// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__3s-qG","topBottomGutter":"Layout_topBottomGutter__2ZFxm"};